import React, { useState, useRef, useEffect } from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { connect } from 'react-redux';
import FloorMarkers from '../widgets/FloorMarkers';
import { storage } from '../../../../config/firebaseConfig';
import * as MDICONS from '@material-ui/icons';
import ReactModal from 'react-modal';
import BriefMarkerWrapper from '../../markers/briefMarker/BriefMarkerWrapper';
import NewMarkerWrapper from '../../markers/newMarker/NewMarkerWrapper';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../../constants/routes';
import { openBriefMarkerModal, openNewMarkerModal } from '../../../../store/actions/sketchActions';
import { get } from 'lodash'
import { testUpdateFloorMarkersInDatastore } from '../../../../store/actions/datastoreActions';
import FloorMarkersList from '../widgets/FloorMarkersList';
import FloorMarkersListMapless from '../widgets/FloorMarkersListMapless';
import { event } from 'jquery';

const definedHeight = 600;
const FloorEditor = (props) => {
    //TODO: GENERAL CONTROL VARIABLES

    // using for list closing modal..
    const [isViewing, setIsViewing] = useState(false);

    const [imgWidth, setImgWidth] = useState(null);
    const [imgHeight, setImgHeight] = useState(null);
    const [scalingFactor, setScalingFactor] = useState(1);
    var [groundValueX, setGroundValueX] = useState(0);
    var [groundValueY, setGroundValueY] = useState(0);
    var [positionValueX, setPositionValueX] = useState(0);
    var [positionValueY, setPositionValueY] = useState(0);
    var [originalX, setOriginalX] = useState(null);
    var [originalY, setOriginalY] = useState(null);
    var [flag, setFlag] = useState(false);
    var [imgUrl, setImgUrl] = useState('');
    var [actualScalingFactor, setActualScalingFactor] = useState(0);

    //TODO: MODAL 
    var [showBriefMarkerModal, setShowBriefMarkerModal] = useState(false);
    var [showNewMarkerModal, setShowNewMarkerModal] = useState(false);

    //TODO: MARKER STATES
    var [selectedMarkerid, setSelectedMarkerid] = useState(null);

    //TODO: GRID TOGGLE
    // const [viewBriefToggle, setViewBriefToggle] = useState(false);
    const [gridToggle, setGridToggle] = useState(true);
    const [gridSize, setGridSize] = useState(25);
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    const [downX, setDownX] = useState(0);
    const [downY, setDownY] = useState(0);
    var [newDownX] = useState(0);
    var [newDownY] = useState(0);

    //TODO: EXPERIMENTAL HINT POINTS
    var [hintPairPoints, setHintPairPoints] = useState([]);
    var [hintPairPointsSpread, setHintPairPointsSpread] = useState([]);

    /* GENERAL CONTROL METHODS */
    /// README: UPDATE IMAGE DIMENSIONS TO CORRECTLY LOAD UP THE SVG AND COORDINATE SYSTEM
    /// WARNING => do not remove this function
    //DOCS: https://stackoverflow.com/questions/61864491/reactjs-get-height-of-a-div-image-using-react-hooks
    const ref = useRef()
    const counterRef = useRef(0); // Just to count loops

    useEffect(() => {
        let cancelled = false;
        const getHeightAndWidth = () => {
            ++counterRef.current;
            const { current } = ref; // `ref` will never be falsy
            if (!current || !current.clientHeight || !current.clientWidth) {
                if (!cancelled) {
                    requestAnimationFrame(getHeightAndWidth);
                }
            } else {
                // Use `current.clientHeight` here
                setImgHeight(current.clientHeight);
                setImgWidth(current.clientWidth);
                setActualScalingFactor(current.clientHeight / definedHeight);

                setFlag(true);
                console.log(`Height is ${current.clientHeight}, getHeight calls: ${counterRef.current}, ${current.clientWidth}`);
            }
        };
        getHeightAndWidth();
        return () => {
            cancelled = true;
        };
    }, []);

    /// README: THIS FUNCTION IS FOR REALTIME POINTER SHOW AND HINT SHAPE BUILDING
    const handleMouseMove = (e) => {
        const layerX = e.nativeEvent.layerX;
        const layerY = e.nativeEvent.layerY;
        setX(layerX);
        setY(layerY);
    }

    /// README: THIS FUNCTION HANDLES UPDATING VARIABLES CORRESPONDING TO USER SHAPE/POINTER SELECTION
    /// WARNING => update this with consent from senior dev
    const handleMouseDown = (e) => {
        const { layerX, layerY } = e.nativeEvent
        newDownX = downX;
        newDownY = downY;
        newDownX = layerX;
        newDownY = layerY;
        // console.log(newDownX, newDownY)
        setDownX(newDownX);
        setDownY(newDownY);
        // var newGroundValueX = (newDownX/scalingFactor)-(positionValueX/actualScalingFactor);
        // var newGroundValueY = (newDownY/ scalingFactor)-(positionValueY/actualScalingFactor);
        var newGroundValueX = (newDownX - (scalingFactor === 1 ? 0 : positionValueX)) / scalingFactor;
        var newGroundValueY = (newDownY - (scalingFactor === 1 ? 0 : positionValueY)) / scalingFactor;
        console.log(newGroundValueX, newGroundValueY)
        setGroundValueX(newGroundValueX);
        setGroundValueY(newGroundValueY);
        console.log(actualScalingFactor)
        var originalCoordinateX = newGroundValueX * actualScalingFactor;
        var originalCoordinateY = newGroundValueY * actualScalingFactor;
        setOriginalX(originalCoordinateX);
        setOriginalY(originalCoordinateY);
        console.log(originalCoordinateX, originalCoordinateY)
        // now open the modal (new marker)
        handleOpenModal();
    }

    /// README: SET MARKER ID AND OPEN MODAL (BRIEF MARKER)
    const handleSetMarkerId = (selectedMarkerid, isViewing) => {
        const { project } = props;
        const { floorMeta } = project;
        const { containsMap, fileName } = floorMeta;
        setSelectedMarkerid(selectedMarkerid);
        if ((isViewing === false) && (containsMap || fileName.length > 0)) {
            handleOpenModal();
        }
        if (isViewing) {
            handleOpenModalMaplessList();
        }
        else {
            handleOpenModalMaplessList();
        }

    }

    /// README: HIGHLY EXPERIMENTAL!!!
    // placing 2 pair of points in order to computed distance between 2 pairs
    // const placeHintPairPoints = (e) => {
    //     const { layerX, layerY } = e.nativeEvent

    //     let downX = layerX;
    //     let downY = layerY;

    //     if (hintPairPoints.length < 2) {
    //         let newHintPairPoints = [...hintPairPoints, [downX, downY]];
    //         let newHintPairPointsSpread = [...hintPairPointsSpread, downX, downY];
    //         setHintPairPoints(newHintPairPoints);
    //         setHintPairPointsSpread(newHintPairPointsSpread);
    //     } else {
    //         setHintPairPoints([]);
    //         setHintPairPointsSpread([]);
    //     }
    // }

    /// README: MODAL CONTROL
    const handleOpenModal = () => {
        const { viewBriefToggle, project } = props;
        const { floorMeta } = project;
        const { containsMap, fileName } = floorMeta;
        if (containsMap || fileName.length > 0) {
            if (viewBriefToggle) {
                props.openBriefMarkerModal();
                setShowBriefMarkerModal(true);
            } else {

                props.openNewMarkerModal();
                setShowNewMarkerModal(true);


            }


        }
        else {
            if (!viewBriefToggle) {
                props.openBriefMarkerModal();
                setShowBriefMarkerModal(true);
            } else {
                props.openNewMarkerModal();
                setShowNewMarkerModal(true);


            }

        }


    }

    const handleOpenModalMapless = (e) => {
        props.openNewMarkerModal();
        setShowNewMarkerModal(true);
    }

    const handleOpenModalMaplessList = (e) => {
        props.openBriefMarkerModal();
        setShowBriefMarkerModal(true);
        setIsViewing(true);
    }
    const handleCloseModalMaplessList = (e) => {
        setShowBriefMarkerModal(false);
        setIsViewing(false);
    }

    const handleCloseModal = () => {
        const { viewBriefToggle, project } = props;
        const { floorMeta } = project;
        const { containsMap, fileName } = floorMeta;

        if (containsMap || fileName.length > 0) {
            if (viewBriefToggle) {
                setShowBriefMarkerModal(false);
            } else {
                setShowNewMarkerModal(false);
            }
        }
        else {
            if (!viewBriefToggle) {
                setShowBriefMarkerModal(false);
            } else {
                setShowNewMarkerModal(false);
            }
        }

    }

    /// README: FUNCTION TO RETURN EUCLIDEAN DISTANCE BETWEEN TWO POINTS
    const getDistanceBetweenPoints = (x1, y1, x2, y2) => {
        var a = x1 - x2;
        var b = y1 - y2;
        return Math.floor(Math.sqrt(a * a + b * b));
    }

    const handleZoomPanChange = (e) => {
        // console.log(e);
        // const tempx = ((1 - e.scale) / e.scale) * imgWidth;
        // const tempy = ((1 - e.scale) / e.scale) * imgHeight;
        // console.log(tempx, tempy, "temp")
        // setPositionValueX(e.positionX > 0 ? 0 : e.positionX < tempx ? tempx : e.positionX);
        // setPositionValueY(e.positionY > 0 ? 0 : e.positionY < tempy ? tempy : e.positionY);
        setPositionValueX(e.positionX);
        setPositionValueY(e.positionY);
        setScalingFactor(e.scale);
    }

    /// ACCESSING PART IMAGE FROM CLOUD STORAGE
    useEffect(() => {
        /// ComponentDidMount
        const { project, floorMarkersList, projectDatastore } = props;
        const { proid, floorMeta } = project;
        const { fileName, containsMap } = floorMeta;

        if (containsMap || fileName.length > 0) {
            // Create a reference to the file we want to download
            var floorRef = storage.ref(`/Projects/${proid}/files/${fileName}.png`);

            // Get the download URL
            floorRef.getDownloadURL().then(url => {
                setImgUrl(url);
            })
        }

        // Update the datastore with markers when entering
        props.updateFloorMarkersInDatastore(floorMeta, floorMarkersList ?? [], projectDatastore ?? {});

        //componentWillUnmount
        // Specify how to clean up after this effect: 
        return function cleanup() {
            const { project, floorMarkersList, projectDatastore } = props;
            const { proid, floorMeta } = project;

            // Update the datastore with markers while leaving
            props.updateFloorMarkersInDatastore(floorMeta, floorMarkersList ?? [], projectDatastore ?? {});
        };
    });

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /// README: FETCHING ALL THE REQUIRED VARIABLES
    const { grid, viewBriefToggle, pointerHintToggle, sketch, modalStyles, userData, alu, snagDetail, project, tagLimitReached, defectMarker, defectMarkers } = props;
    const { markerAdditionAccess } = alu;
    const { uid, employeeid } = userData;
    const { floorMeta } = project;
    const { containsMap, fileName } = floorMeta;
    const { isMarkerCreated, isBriefForceClose } = sketch;
    /// this is placed to pause snagDetail related stuff while snagDetail is not available
    if (!snagDetail) {
        return <React.Fragment />
    }

    const { accessMap } = snagDetail;

    /// README: CHECKING ACCESS LEVEL FOR RECODING AND EDITING
    /// getting ueid to pass into accessMap of project to get accessLevel
    var ueid = uid + employeeid;
    var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
    var isMarkerAdditionAllowed = markerAdditionAccess[accessLevel];

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /// README: POINTERS
    const primaryPointer = <circle cx={x} cy={y} r={4} fill="black" />
    const downPointer = <circle cx={downX} cy={downY} r={5} fill="blue" />

    /// README: HINT POINTER
    const hintPointers = hintPairPoints.length > 0 ? hintPairPoints.map((val, i) => (
        <circle cx={val[0]} cy={val[1]} r={3} fill="green" key={i} />
    )) : null;
    // const lineBetweenHintPointers = hintPairPointsSpread.length >= 2 ? <line x1={hintPairPointsSpread[0]} y1={hintPairPointsSpread[1]} x2={hintPairPointsSpread.length === 4 ? hintPairPointsSpread[2] : x} y2={hintPairPointsSpread.length === 4 ? hintPairPointsSpread[3] : y} style={{ stroke: "green", strokeWidth: "2" }} /> : null;
    // const lineLengthHintPointers = hintPairPointsSpread.length >= 2 ? <text x={hintPairPointsSpread.length === 4 ? hintPairPointsSpread[2] : x - 30} y={hintPairPointsSpread.length === 4 ? hintPairPointsSpread[3] : y - 30} fill="black" fontSize="17px" fontWeight="bold">{getDistanceBetweenPoints(hintPairPointsSpread.length === 4 ? hintPairPointsSpread[2] : x, hintPairPointsSpread.length === 4 ? hintPairPointsSpread[3] : y, hintPairPointsSpread[0], hintPairPointsSpread[1])}</text> : null;
    var scaledDownImageHeight = definedHeight;
    // var actualScalingFactor = imgHeight / scaledDownImageHeight;
    var scaledDownImageWidth = imgWidth / actualScalingFactor;
    const viewMode =
        // README: Don't change the property without permission..
        <TransformWrapper
            onPanning={handleZoomPanChange}
            onZoomChange={handleZoomPanChange}
            options={{
                minScale: 1,
                maxScale: 10,

            }}
            pan={{
                // README: out of bounds avoidness
                // paddingSize default is 30px
                paddingSize: 0,
                animationTime: 0,
                velocityBaseTime: 0,
                velocityMinSpeed: 0,
                velocity: 0,
                velocityEqualToMove: false
            }}
            zoomIn={{
                animation: false,
                animationTime: 0,

            }}
            zoomOut={{
                animationTime: 0,
                animation: false,
            }}
            doubleClick={{
                animationTime: 0,
                animation: false,
                disabled: true

            }}
            reset={{
                animation: false,
                animationTime: 0,
            }}
            wheel={{
                disabled: true,

            }}



        >
            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                <React.Fragment>

                    <div className={tagLimitReached ? 'blur-background' : ''} style={{ width: `${scaledDownImageWidth}px` }} >
                        <div className="tools" style={{marginBottom:'10px'}}>
                            <div className="btn-group" role="group" >
                                <button type="button" className="card" onClick={() => zoomIn(event)}><MDICONS.AddCircle /></button>
                                <button type="button" className="card" onClick={() => zoomOut(event)}><MDICONS.RemoveCircle/></button>
                                <button type="button" className="card" onClick={() => resetTransform(event)}><MDICONS.Cancel/></button>
                            </div>
                           </div>
                        <TransformComponent >
                            <div style={{ height: `${definedHeight}px` }}>
                                <img src={imgUrl} alt="" ref={ref} style={flag ? { height: `${definedHeight}px` } : {}} />
                            </div>

                            <div className="sketch-box sketch-stack-top">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={`${scaledDownImageWidth}`}
                                    height={`${scaledDownImageHeight}`}
                                >
                                    <FloorMarkers actualScalingFactor={actualScalingFactor} scalingFactor={scalingFactor} handleSetMarkerId={handleSetMarkerId} />
                                </svg>
                            </div>

                        </TransformComponent>
                        

                        {viewBriefToggle ? <React.Fragment /> :

                            <div style={{ width: `${scaledDownImageWidth}px` }} onMouseMove={handleMouseMove} onMouseDown={handleMouseDown}>

                                <div className="sketch-box sketch-stack-top">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={`${scaledDownImageWidth}`}
                                        height={`${scaledDownImageHeight}`}
                                    >
                                        {/* DRAW GRID */}

                                        {/* {grid} 
                                {primaryPointer} */}

                                        {/* DRAW GRID */}
                                        {/* {grid} */}

                                        {/* DRAW MARKERS */}


                                        {/* HINT LAYER */}
                                        {hintPointers}
                                        {/* {lineBetweenHintPointers}
                                    {lineLengthHintPointers} */}

                                        {/* POINTERS */}
                                        {!viewBriefToggle ? downPointer : null}
                                        {!viewBriefToggle || pointerHintToggle === true ? primaryPointer : null}

                                    </svg>
                                </div>

                            </div>
                        }

                    </div>
                    {tagLimitReached ?
                        <div className="bg-text card d-flex align-items-center" style={{ width: `${scaledDownImageWidth}px`, position: 'absolute', borderRadius: '10px' }}>
                            <MDICONS.Lock scale={0.5} />
                            <p className="py-3">Unlock the asset map and list by getting a premium subscription</p>
                            <p><Link to={ROUTES.PRICING} className="mx-2" style={{ color: 'black' }}><b>Check out the plans here!</b></Link></p>
                        </div>


                        : <React.Fragment />}
                </React.Fragment>
            )}
        </TransformWrapper>;
    return (
        <React.Fragment>
            {containsMap || fileName.length > 0 ?
                <div className="container-fluid">

                    {/* First Row */}
                    <div className="row mt-2">
                        <div className="col col-2"></div>
                        <div className="col col-6">
                            {/* <p style={{ fontSize: "15px", fontWeight: "bold", color: `${viewBriefToggle ? "darkgreen" : "darkblue"}`, textAlign: "end" }}>
                                {viewBriefToggle ? "In view mode 👁" : "In recording mode ⬤"} | Mouse coordinates: {x}, {y} | Clicked: {downX}, {downY} */}
                            {/* Original{originalX}, {originalY} | posX{positionValueX}, posY{positionValueY} */}
                            {/* </p> */}
                            {/* <p className="py-3">Unlock the dashboard by getting a premium subscription</p> */}
                        </div>
                        <div className="col col-4"> <p style={{ fontSize: '20px', fontWeight: 'bold', color: 'darkblue', }}></p></div>
                    </div>

                    {/* Second Row (Main) */}
                    <div className="row mt-2">
                        <div className="d-flex justify-content-center col col-8">{viewMode}</div>
                        <div className="col col-4">
                            <FloorMarkersList defectMarker={defectMarker} defectMarkers={defectMarkers} tagLimitReached={tagLimitReached}
                                handleSetMarkerId={handleSetMarkerId} /></div>
                    </div>
                </div>
                : <FloorMarkersListMapless isMarkerAdditionAllowed={isMarkerAdditionAllowed} defectMarkers={defectMarkers} defectMarker={defectMarker} tagLimitReached={tagLimitReached} handleOpenModalMapless={handleOpenModalMapless} handleOpenModalMaplessList={handleOpenModalMaplessList} handleSetMarkerId={handleSetMarkerId} />
            }



            {/* NEW MARKER MODAL */}
            <ReactModal
                style={modalStyles}
                isOpen={(showNewMarkerModal && !isMarkerCreated === true) && isMarkerAdditionAllowed}
                onRequestClose={handleCloseModal}
                contentLabel="New marker modal"
                ariaHideApp={false}

            >
                <button className="close" onClick={handleCloseModal}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <NewMarkerWrapper defectMarkers={defectMarkers} defectMarker={defectMarker} downX={containsMap || fileName.length > 0 ? originalX : 0} downY={containsMap || fileName.length > 0 ? originalY : 0} isElevationMap={false} containsMap={containsMap} fileName={fileName} />
            </ReactModal>
            {/* BRIEF MARKER MODAL */}
            <ReactModal
                style={modalStyles}
                isOpen={showBriefMarkerModal && !isBriefForceClose === true}
                onRequestClose={containsMap && isViewing === false ? handleCloseModal : handleCloseModalMaplessList}
                contentLabel="Brief marker modal"
                ariaHideApp={false}

            >
                <button className="close" onClick={containsMap && isViewing === false ? handleCloseModal : handleCloseModalMaplessList}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <BriefMarkerWrapper defectMarkers={defectMarkers} defectMarker={defectMarker} selectedMarkerid={selectedMarkerid} isElevationMap={false} />
            </ReactModal>
        </React.Fragment>


    )
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        userData: state.firebase.profile,
        modalStyles: state.appControl.modalStyles,
        alu: state.alu,
        sketch: state.sketch,
        floor: state.floor,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        // floorMarkers: state.firestore.data.FloorMarkers,
        // floorMarkersList: state.firestore.ordered.FloorMarkers,
        projectDatastore: state.datastore.projectDatastore,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openNewMarkerModal: () => dispatch(openNewMarkerModal()),
        openBriefMarkerModal: () => dispatch(openBriefMarkerModal()),
        updateFloorMarkersInDatastore: (floorMeta, floorMarkersList, projectDatastore) => dispatch(testUpdateFloorMarkersInDatastore(floorMeta, floorMarkersList, projectDatastore)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FloorEditor);